import { render, staticRenderFns } from "./Methodology.vue?vue&type=template&id=f97e915e&scoped=true&"
import script from "./Methodology.vue?vue&type=script&lang=js&"
export * from "./Methodology.vue?vue&type=script&lang=js&"
import style0 from "./Methodology.vue?vue&type=style&index=0&id=f97e915e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97e915e",
  null
  
)

export default component.exports